import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "notas-locais"
  }, [_c('div', {
    staticClass: "notas-header"
  }, [_c('div', {
    staticClass: "notas-header__left"
  }, [_c('h1', {
    staticClass: "notas-header__title"
  }, [_vm._v("Notas Fiscais Locais")]), !_vm.carregando ? _c('span', {
    staticClass: "notas-header__count"
  }, [_vm._v(" " + _vm._s(_vm.notasFiltradas.length) + " registro(s) ")]) : _vm._e()]), _c('div', {
    staticClass: "notas-header__right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-secondary mr-2",
    attrs: {
      "title": "Recarregar lista"
    },
    on: {
      "click": _vm.carregar
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt"
  })]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'pdvDesktopNovaVenda'
        });
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle mr-1"
  }), _vm._v(" Nova Venda ")])])]), _c('div', {
    staticClass: "notas-filtros"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filtro.busca,
      expression: "filtro.busca"
    }],
    staticClass: "form-control notas-filtros__busca",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por número, cliente ou chave..."
    },
    domProps: {
      "value": _vm.filtro.busca
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.filtro, "busca", $event.target.value);
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filtro.statusFiscal,
      expression: "filtro.statusFiscal"
    }],
    staticClass: "form-control notas-filtros__status",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filtro, "statusFiscal", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos (fiscal)")]), _c('option', {
    attrs: {
      "value": "pendente_xml"
    }
  }, [_vm._v("Pendente XML")]), _c('option', {
    attrs: {
      "value": "xml_gerado"
    }
  }, [_vm._v("XML Gerado")]), _c('option', {
    attrs: {
      "value": "transmitida"
    }
  }, [_vm._v("Transmitida")]), _c('option', {
    attrs: {
      "value": "autorizada"
    }
  }, [_vm._v("Autorizada")]), _c('option', {
    attrs: {
      "value": "rejeitada"
    }
  }, [_vm._v("Rejeitada")])]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filtro.statusSync,
      expression: "filtro.statusSync"
    }],
    staticClass: "form-control notas-filtros__status",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filtro, "statusSync", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos (sync)")]), _c('option', {
    attrs: {
      "value": "pendente"
    }
  }, [_vm._v("Pendente Sync")]), _c('option', {
    attrs: {
      "value": "sincronizada"
    }
  }, [_vm._v("Sincronizada")]), _c('option', {
    attrs: {
      "value": "erro"
    }
  }, [_vm._v("Erro Sync")])])]), _vm.carregando ? _c('div', {
    staticClass: "notas-loading"
  }, [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-2"
  }), _vm._v(" Carregando... ")]) : _vm.notasFiltradas.length > 0 ? _c('div', {
    staticClass: "notas-table-wrapper"
  }, [_c('table', {
    staticClass: "table table-hover notas-table"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.notasFiltradas, function (nota) {
    return _c('tr', {
      key: nota.uuid_venda_terminal || nota.id
    }, [_c('td', {
      staticClass: "font-weight-bold"
    }, [_vm._v(" " + _vm._s(nota.numeroNota || nota.id) + " ")]), _c('td', [_vm._v(_vm._s(_vm.formatarData(nota.emissao || nota.dtVenda || nota.created_at)))]), _c('td', [_vm._v(_vm._s(nota.nomeCliente || '—'))]), _c('td', [_vm._v(_vm._s(nota.serie || '—'))]), _c('td', {
      staticClass: "notas-table__chave",
      attrs: {
        "title": nota.chave
      }
    }, [_vm._v(" " + _vm._s(nota.chave ? nota.chave.substring(0, 22) + '...' : '—') + " ")]), _c('td', {
      staticClass: "text-right font-weight-bold"
    }, [_vm._v(" " + _vm._s(_vm.formatarValor(nota.valorTotal)) + " ")]), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "badge",
      class: _vm.badgeFiscal(nota.status_fiscal)
    }, [_vm._v(" " + _vm._s(_vm.labelFiscal(nota.status_fiscal)) + " ")]), _vm.gerandoXml[nota.uuid_venda_terminal] ? _c('div', {
      staticClass: "notas-xml-spinner"
    }, [_c('span', {
      staticClass: "spinner-border spinner-border-sm"
    })]) : _vm._e(), _vm.erroXml[nota.uuid_venda_terminal] ? _c('div', {
      staticClass: "notas-xml-erro",
      attrs: {
        "title": _vm.erroXml[nota.uuid_venda_terminal]
      }
    }, [_c('i', {
      staticClass: "fas fa-exclamation-circle text-danger"
    }), _c('small', {
      staticClass: "text-danger"
    }, [_vm._v("Erro")])]) : _vm._e()]), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      class: ['badge', nota.status_sync === 'sincronizada' ? 'badge-success' : nota.status_sync === 'erro' ? 'badge-danger' : 'badge-warning']
    }, [_vm._v(" " + _vm._s(nota.status_sync === 'sincronizada' ? '✓ Sync' : nota.status_sync === 'erro' ? 'Erro' : 'Pendente') + " ")])]), _c('td', {
      staticClass: "text-center notas-table__acoes"
    }, [nota.status_fiscal === 'pendente_xml' ? _c('button', {
      staticClass: "btn btn-sm btn-warning mr-1",
      attrs: {
        "title": "Gerar XML NFC-e",
        "disabled": !!_vm.gerandoXml[nota.uuid_venda_terminal]
      },
      on: {
        "click": function click($event) {
          return _vm.gerarXml(nota);
        }
      }
    }, [_vm.gerandoXml[nota.uuid_venda_terminal] ? _c('span', [_c('span', {
      staticClass: "spinner-border spinner-border-sm"
    })]) : _c('span', [_c('i', {
      staticClass: "fas fa-file-code"
    })])]) : ['xml_gerado', 'rejeitada'].includes(nota.status_fiscal) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-warning mr-1",
      attrs: {
        "title": "Re-gerar XML NFC-e",
        "disabled": !!_vm.gerandoXml[nota.uuid_venda_terminal]
      },
      on: {
        "click": function click($event) {
          return _vm.gerarXml(nota);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-redo"
    })]) : _vm._e(), nota.xml ? _c('button', {
      staticClass: "btn btn-sm btn-light-info mr-1",
      attrs: {
        "title": "Visualizar / copiar XML"
      },
      on: {
        "click": function click($event) {
          return _vm.verXml(nota);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-code"
    })]) : _vm._e(), _vm.erroXml[nota.uuid_venda_terminal] ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger mr-1",
      attrs: {
        "title": "Ver erro da geração"
      },
      on: {
        "click": function click($event) {
          return _vm.verErroXml(nota);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-exclamation-triangle"
    })]) : _vm._e(), nota.xml_assinado || nota.status_fiscal === 'autorizada' ? _c('button', {
      staticClass: "btn btn-sm btn-success mr-1",
      attrs: {
        "title": "Visualizar / Imprimir DANFE NFC-e"
      },
      on: {
        "click": function click($event) {
          _vm.modalDanfe = {
            visivel: true,
            uuid: nota.uuid_venda_terminal
          };
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-receipt"
    })]) : _vm._e()])]);
  }), 0)])]) : _c('div', {
    staticClass: "notas-vazio"
  }, [_c('i', {
    staticClass: "fas fa-file-invoice fa-3x text-muted mb-3"
  }), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Nenhuma nota encontrada.")]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'pdvDesktopNovaVenda'
        });
      }
    }
  }, [_vm._v(" Nova Venda ")])]), _vm.modalXml.visivel ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        _vm.modalXml.visivel = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-xml"
  }, [_c('div', {
    staticClass: "modal-xml__header"
  }, [_c('div', [_c('h4', [_vm._v("XML NFC-e — Nota #" + _vm._s(_vm.modalXml.nota && (_vm.modalXml.nota.numeroNota || _vm.modalXml.nota.numero)))]), _vm.modalXml.nota && _vm.modalXml.nota.chave ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Chave: " + _vm._s(_vm.modalXml.nota.chave) + " ")]) : _vm._e()]), _c('button', {
    staticClass: "btn btn-sm btn-light",
    on: {
      "click": function click($event) {
        _vm.modalXml.visivel = false;
      }
    }
  }, [_vm._v("✕")])]), _c('pre', {
    staticClass: "modal-xml__content"
  }, [_vm._v(_vm._s(_vm.modalXml.conteudo))]), _c('div', {
    staticClass: "modal-xml__footer"
  }, [_vm.copiado ? _c('span', {
    staticClass: "text-success mr-3 font-weight-bold"
  }, [_c('i', {
    staticClass: "fas fa-check mr-1"
  }), _vm._v("Copiado! ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    on: {
      "click": _vm.copiarXml
    }
  }, [_c('i', {
    staticClass: "fas fa-copy mr-1"
  }), _vm._v("Copiar XML ")])])])]) : _vm._e(), _vm.modalErro.visivel ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        _vm.modalErro.visivel = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-confirm"
  }, [_vm._m(1), _c('p', {
    staticClass: "text-muted mb-1"
  }, [_vm._v(" Nota #" + _vm._s(_vm.modalErro.nota && (_vm.modalErro.nota.numeroNota || _vm.modalErro.nota.numero)) + " ")]), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "font-size": "0.85rem",
      "word-break": "break-word"
    }
  }, [_vm._v(" " + _vm._s(_vm.modalErro.mensagem) + " ")]), _c('div', {
    staticClass: "modal-confirm__actions"
  }, [_c('button', {
    staticClass: "btn btn-secondary mr-2",
    on: {
      "click": function click($event) {
        _vm.modalErro.visivel = false;
      }
    }
  }, [_vm._v("Fechar")]), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function click($event) {
        _vm.gerarXml(_vm.modalErro.nota);
        _vm.modalErro.visivel = false;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-redo mr-1"
  }), _vm._v("Tentar Novamente ")])])])]) : _vm._e(), _c('DanfeNfce', {
    attrs: {
      "visivel": _vm.modalDanfe.visivel,
      "uuid": _vm.modalDanfe.uuid
    },
    on: {
      "fechar": function fechar($event) {
        _vm.modalDanfe.visivel = false;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("N°/Nota")]), _c('th', [_vm._v("Emissão")]), _c('th', [_vm._v("Cliente")]), _c('th', [_vm._v("Sér.")]), _c('th', [_vm._v("Chave de Acesso")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Total")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Fiscal")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Sync")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ações")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h4', {
    staticClass: "modal-confirm__title text-danger"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-circle mr-2"
  }), _vm._v("Erro na Geração do XML ")]);
}];
export { render, staticRenderFns };